import { UpdateTransferMutationProvider } from "__legacy/queries/projects/UpdateTransferMutationProvider";
import { Button, Card, Col, Drawer, Form, Row } from "antd";
import { Fragment, useState } from "react";
import { useParams } from "react-router";

import { onFinish, PwsTransferForm } from "./PwsTransferForm";

type PwsTransferCardType = {
  project: any;
  editable: boolean;
};

export const PwsTransferCard: React.FC<PwsTransferCardType> = (props) => {
  const { project, editable } = props;
  const { id } = useParams();
  const title = "Transfer";
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  const [drawerVisible, setDrawerVisible] = useState(false);
  const onClose = () => setDrawerVisible(false);

  const [Mutation, params, variables] = [UpdateTransferMutationProvider, {}, { id }];

  const onError = () => ({ graphQLErrors }: any) => {
    const errors: string[] = [];
    graphQLErrors.forEach((graphQLError: any) => {
      errors.push(graphQLError.message);
    });
    setErrors(errors);
  };

  const filled = project.transferFilled;

  return (
    <Fragment>
      <Card
        title={title}
        bodyStyle={filled ? {} : { display: "none" }}
        extra={
          editable && (
            <Button type={filled ? "ghost" : "primary"} onClick={() => setDrawerVisible(true)}>
              {filled ? "Edit" : "Fill"}
            </Button>
          )
        }
      >
        <Row gutter={[24, 24]}>
          <Col span={12}>
            Existing Cb: <b>{project.existingAuthority}</b>
          </Col>
          <Col span={12}>
            Existing Accreditation: <b>{project.existingAccreditation}</b>
          </Col>
          <Col span={12}>
            Cerfiticate Expiry Date: <b>{project.existingCertificateExpiredOn}</b>
          </Col>
          <Col span={12}>
            Original Cerfiticate Date: <b>{project.existingCertificateIssuedOn}</b>
          </Col>
          <Col span={12}>
            Existing Certificate:{" "}
            {project.existingCertificate && (
              <b>
                <a href={project.existingCertificate} download>
                  Download
                </a>
              </b>
            )}
          </Col>
          <Col span={12}>
            Previous CB Report:{" "}
            {project.existingAuthorityReport && (
              <b>
                <a href={project.existingAuthorityReport} download>
                  Download
                </a>
              </b>
            )}
          </Col>
          <Col span={24}>
            Transfer Reason: <b>{project.transferReason}</b>
          </Col>
        </Row>
      </Card>
      <Mutation onError={onError}>
        {(loading, mutate) => (
          <Drawer
            title={title}
            width={680}
            onClose={onClose}
            visible={drawerVisible}
            keyboard={false}
            maskClosable={false}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Button onClick={onClose} style={{ marginRight: 8 }}>
                  Cancel
                </Button>
                <Button type="primary" loading={loading} onClick={() => form.submit()}>
                  Save
                </Button>
              </div>
            }
          >
            <PwsTransferForm
              form={form}
              project={project}
              onFinish={onFinish(mutate, params, variables)}
              errors={errors}
            />
          </Drawer>
        )}
      </Mutation>
    </Fragment>
  );
};
